module.exports = __webpack_public_path__ + "img/embroidery.ceaff336.svg";